import { render, staticRenderFns } from "./createGlobalSearch.vue?vue&type=template&id=08e36246&"
import script from "./createGlobalSearch.vue?vue&type=script&lang=js&"
export * from "./createGlobalSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports